import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jsinglinherit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
  <title>Java single inheritance tutorial For Beginners</title>
<meta name="description" content="Java single inheritance tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java single inheritance,single inheritance in java
,single inheritance in java program,single level inheritance in java example,java program for single inheritance,single inheritance in java with example,single inheritance in java example,single inheritance using constructor in java,single inheritance in oop java,single inheritance in java definition" />
<link rel="canonical" href="https://www.codeexampler.com/java-single-inheritance" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Single Inheritance in Java
</h1>
<div className="first">
        <a href="/java-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-multilevel-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div> 


<h2 className="headings">Q-Write a Program example of inheritance in java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> students</span>
          <span className="qwerty-2"> {`// superclass or parent class`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;void </span>
          <span className="qwerty-8">learn</span>
          <span className="qwerty-1">()</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"this is a students"</span>         
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}
          <span className="qwerty-3">&#125; </span>
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> teachers</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> students</span>
      <span className="qwerty-2"> {`// teachers is a child class`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>   
          {"\n"}       
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-10">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-9">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"} 
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;teachers</span>
          <span className="qwerty-3"> t</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-5">new </span>
          <span className="qwerty-4">teachers</span>
          <span className="qwerty-1">();</span>
          {"\n"} 
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;t</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-8">learn</span>
          <span className="qwerty-1">();</span>

          {"\n"}
         
    
    
    
    
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"} 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-9">&nbsp;this is a students</span>
          {"\n"}              
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program Example of Single Inheritance in java?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> students</span>
              <span className="qwerty-2"> {`// or parent class`}</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;void </span>
              <span className="qwerty-8">learn</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"this is a students"</span>         
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}
              <span className="qwerty-3">&#125; </span>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> teachers</span>
          <span className="qwerty-8"> extends</span>
          <span className="qwerty-4"> students</span>
          <span className="qwerty-2"> {`// teachers is a child class`}</span>
              {"\n"}
              
              <span className="qwerty-3">&#123; </span>   
              {"\n"}       
              <span className="qwerty-3">&nbsp;&nbsp;void </span>
              <span className="qwerty-8">learn</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"this is a teacher"</span>         
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"} 
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;teachers</span>
              <span className="qwerty-3"> t</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">teachers</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;t</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-8">learn</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;t</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-8">study</span>
              <span className="qwerty-1">();</span>
    
              {"\n"}
             
        
        
        
        
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
        
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-9">&nbsp;this is a students</span>
              {"\n"} 
              <span className="qwerty-9">&nbsp;this is a teacher</span>
              {"\n"}              
                </code>{"   "}
                </pre>
          </div>
        </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-multilevel-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jsinglinherit;